// material
import { Stack, Box } from "@mui/material";
import "./CultureMaker.css";
// ----------------------------------------------------------------------

export default function MakerContent() {
  return (
    <Stack direction={{ xs: "column", md: "row" }}>
      <Stack alignItems="center" sx={{ width: { sm: "100%", md: "50%" } }}>
        <Box
          component="img"
          src="/assets/RHOOD4.png"
          sx={{ width: { xs: "65%", md: "100%" }, height: "auto" }}
        />
      </Stack>
      <Stack sx={{ width: { sm: "100%", md: "50%" } }}>
        <Stack
          sx={{
            borderBottom: "1px solid #ffffff80",
            fontFamily: "Helvetica",
            fontSize: "42px",
            color: "#fff",
            lineHeight: 1.1,
            p: "9%",
            textAlign: "initial",
          }}
        >
          EARN TOKENS BY CONTRIBUTION
        </Stack>
        <Stack spacing={5} sx={{ p: "7% 9%" }}>
          <p className="maker_content">
            This token cannot be bought, only earned. <br /> By contributing to
            our community with art, music and creativity you will earn your
            “Culture Maker” status. This creates a separate token, with access
            to all top-tier utilities and forms an exclusive community of other
            creators.
          </p>
          <p className="maker_content">
            You as a community and token holders will be able to receive funding
            for collaborations with other Culture Maker holders by the R/HOOD
            treasury.
          </p>
          <p className="maker_content">
            As part of R/HOOD’s roadmap, you as a Culture Maker Holder will also
            get connected with some of the top brands in the world and together
            will R/HOOD be part of creating innovating culture-first campaigns
            with these brands and build on your portfolio.
          </p>
          <p className="maker_content">
            The Culture Maker Holders will only contain creative people. A
            community by the creators, for the creators.
          </p>
        </Stack>
      </Stack>
    </Stack>
  );
}
